import { useWebWidgetStore } from '../store/store.ts'

export const useIsEmbedAutoHeight = (): boolean => useWebWidgetStore(state => state.embedAutoHeight)
